/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VolunteerOfMonthDto } from '../../models/volunteer-of-month-dto';
import { VolunteerOfMonthMetric } from '../../models/volunteer-of-month-metric';

export interface VolunteerStatsPublicControllerGetVolunteerOfTheMonth$Params {

/**
 * Which metric decides the winner (default: points)
 */
  metric?: VolunteerOfMonthMetric;

/**
 * Month in YYYY-MM (default: current month)
 */
  month?: string;
}

export function volunteerStatsPublicControllerGetVolunteerOfTheMonth(http: HttpClient, rootUrl: string, params?: VolunteerStatsPublicControllerGetVolunteerOfTheMonth$Params, context?: HttpContext): Observable<StrictHttpResponse<VolunteerOfMonthDto>> {
  const rb = new RequestBuilder(rootUrl, volunteerStatsPublicControllerGetVolunteerOfTheMonth.PATH, 'get');
  if (params) {
    rb.query('metric', params.metric, {});
    rb.query('month', params.month, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VolunteerOfMonthDto>;
    })
  );
}

volunteerStatsPublicControllerGetVolunteerOfTheMonth.PATH = '/public/volunteer-of-the-month';
